class ToggleOverflow {
    constructor(el) {
        this.scope = el;
        const targetSelector = this.scope.getAttribute('data-toggle-overflow');
        this.target = document.querySelector(targetSelector);
        if (this.target) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.scope.addEventListener('click', (e) => {
            e.preventDefault();
            this.target.classList.toggle("overflow-hidden");
        });
    }
}

ControlBinders.register("[data-toggle-overflow]", elm => new ToggleOverflow(elm));